import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

// Utilizar jquery y jquery confirm
import * as $ from 'jquery/dist/jquery.min.js';
import 'jquery-confirm';

// Componentes para la modal ngb
import { EmpleadosModalComponent } from '../components/modals/lista-empleados/empleados-modal.component';
import { DenegarComponent } from '../components/modals/denegar/denegar.component';
import { BusquedaAvanzadaComponent } from '../components/modals/busqueda-avanzada/busqueda-avanzada.component';
import { EditarRutaComponent } from '../components/modals/editar-ruta/editar-ruta.component';
import { VistaMapaComponent } from '../components/modals/vista-mapa/vista-mapa.component';
import { RecorridosComponent } from '../components/modals/recorridos/recorridos.component';
import { ReciboIngresoComponent } from '../components/modals/recibo-ingreso/recibo-ingreso.component';
import { AsignarRutasEmpleadoComponent } from '../components/modals/asignar-rutas-empleado/asignar-rutas-empleado.component';
import { EditarPassComponent } from '../components/modals/editar-pass/editar-pass.component';
import { ConfirmComponent } from '../components/modals/confirm/confirm.component';
import { DetalleComponent } from '../components/modals/detalle/detalle.component';
import { ComentarioClienteComponent } from '../components/modals/comentario-cliente/comentario-cliente.component';
import { RecordatorioComponent } from '../components/modals/recordatorio/recordatorio.component';
import { DetalleAperturaComponent } from '../components/modals/detalle-apertura/detalle-apertura.component';
import { PromptComponent } from '../components/modals/prompt/prompt.component';
import { AccesoClienteComponent } from '../components/modals/acceso-cliente/acceso-cliente.component';
import { DescuentoCuotaComponent } from '../components/modals/descuento-cuota/descuento-cuota.component';
import { EditarGastosComponent } from '../components/modals/editar-gastos/editar-gastos.component';
import { RecordatoriosModalComponent } from '../components/modals/recordatorios/recordatorios.component';
import { RestablecerContrasenaComponent } from '../components/modals/restablecer-contrasena/restablecer-contrasena.component';
import { PreguntasSecretasComponent } from '../components/modals/preguntas-secretas/preguntas-secretas.component';
import { CartasPdfComponent } from '../components/modals/cartas-pdf/cartas-pdf.component';
import { PagareNotarialModalComponent } from '../components/modals/pagare-notarial-modal/pagare-notarial-modal.component';
import { EditarAperturaComponent } from '../components/modals/editar-apertura/editar-apertura.component';
// tslint:disable-next-line:max-line-length
import { RecuperarClienteDatacreditoComponent } from '../components/modals/recuperar-cliente-datacredito/recuperar-cliente-datacredito.component';
import { PausarMoraComponent } from '../components/modals/pausar-mora/pausar-mora.component';
import { CartaSaldoModalComponent } from '../components/modals/carta-saldo/carta-saldo.component';
import { DetalleNotaCreditoComponent } from '../components/modals/detalle-nota-credito/detalle-nota-credito.component';
import { TimingComponent } from '../components/modals/timing/timing.component';
import { AsignarCompaniaEmpleadoComponent } from '../components/modals/asignar-compania-empleado/asignar-compania-empleado.component';
import { NotasClienteComponent } from '../components/modals/notas-cliente/notas-cliente.component';
import { HistorialPagoPrestamoComponent } from '../components/modals/historial-pago-prestamo/historial-pago-prestamo.component';
import { ImportarClientesRutaComponent } from '../components/modals/importar-clientes-ruta/importar-clientes-ruta.component';
import { CerrarDiaComponent } from '../components/modals/cerrar-dia/cerrar-dia.component';
import { DetalleCierreDiaComponent } from '../components/modals/detalle-cierre-dia/detalle-cierre-dia.component';
import { AsignarPaginaComponent } from '../components/modals/asignar-pagina/asignar-pagina.component';
import { AsignarPermisoComponent } from '../components/modals/asignar-permiso/asignar-permiso.component';
import { RegionComponent } from '../components/modals/region/region.component';
import { SubregionComponent } from '../components/modals/subregion/subregion.component';
import { SeleccionarEmpleadoComponent } from '../components/modals/seleccionar-empleado/seleccionar-empleado.component';
import { DetalleSolicitudComponent } from '../components/modals/detalle-solicitud/detalle-solicitud.component';
import { PrestamosService } from '../services/prestamos.service';
import { VerFotosClienteComponent } from '../components/modals/ver-fotos-cliente/ver-fotos-cliente.component';
import { HistorialTelefonoComponent } from '../components/modals/historial-telefono/historial-telefono.component';
import { TokenComponent } from '../components/modals/token/token.component';

declare var $: any;

@Injectable()
export  class AlertasModales  {
    constructor(private modalService: NgbModal) {}

   // Abrir modal jquery confirm
    agregarClienteModalJquery( navigate: any, ID: any, titulo: string,
        btnText: string,
        type: string,
        theme: string = 'modern',
        btnColor: string = 'btn-green',
        icon: string = 'fa fa-user') {
    $.confirm({
        title: titulo,
        content: '',
        theme: theme,
        type: type,
        icon,
        closeIcon: true,
        typeAnimated: true,
        buttons: {
            boton: {
                text: btnText,
                btnClass: btnColor,
                action: function() {
                    // Guardar la ID del cliente en un localStorage
                    localStorage.setItem('nuevoCliente', ID);
                 navigate.navigate(['/prestamo']);
                }
            }
        }
    });
    }


    // Modal para los errores de validaciones
    validacionesModalJquery( titulo: string, contenido, type: string, theme: string = 'light', isArr = false, icon = 'fa fa-close') {

        $.alert({
           title: titulo,
           closeIcon: true,
           columnClass: 'col-md-6  col-md-offset-4',
           content: (isArr ? contenido.map((item) => `${item}. <br>`) : contenido),
           theme: theme,
           type: type,
           icon,
           typeAnimated: true
        });
   }

    errorModalJquery( navigate: any, ID: any, nav: string, title: string, content,
        btnText: string,
        type: string,
        theme: string = 'modern',
        btnColor: string = 'btn-green',
        icon: string = 'fa fa-user') {
        $.confirm({
            title,
            content,
            theme: theme,
            type: type,
            icon,
            closeIcon: true,
            typeAnimated: true,
            buttons: {
                prestamo: {
                    text: btnText,
                    btnClass: btnColor + ' btn-block',
                    action: function() {
                     navigate.navigate([`/${nav}`, ID]);
                    }
                },
            }
        });
    }

    errorClienteNoExiste( navigate: any, title: string, content,
        btnText: string,
        type: string,
        theme: string = 'modern',
        btnColor: string = 'btn-red',
        icon: string = 'fa fa-user') {
        $.confirm({
            title,
            content,
            theme: theme,
            type: type,
            icon,
            closeIcon: true,
            typeAnimated: true,
            buttons: {
                prestamo: {
                    text: btnText,
                    btnClass: btnColor + ' btn-block',
                    action: function() {
                     navigate.navigate([`/agregar/cliente`]);
                    }
                },
            }
        });
    }

   correctoModalJquery( titulo: string, type: string, theme = 'light', icon: string = 'fa fa-map', content: string = '' ) {
       $.alert({
           title: titulo,
           closeIcon: true,
           columnClass: 'col-md-6  col-md-offset-4',
           content,
           theme,
           type,
           icon,
           typeAnimated: true
       });
   }

    listaEmpleadosModalJquery( titulo: string, component: any ) {
        console.log(component);
        $.alert({
            title: titulo,
            closeIcon: true,
            columnClass: 'col-md-8  col-md-offset-4',
            content: component,
            typeAnimated: true
        });
    }

    listaEmpleadosNgbModal(ruta) {
      const modalRef = this.modalService.open(EmpleadosModalComponent, { centered: true, backdrop: 'static' });
      modalRef.componentInstance.ruta = ruta;
    //   modalRef.result.then(res => {
    //       console.log(res);
    //   });
    }
    asignarRutaEmpleadosNgbModal(empleado, rutasAsignadas: Array<any>) {
      const modalRef = this.modalService.open(AsignarRutasEmpleadoComponent, { centered: true, backdrop: 'static' });
      modalRef.componentInstance.empleado = empleado;
      modalRef.componentInstance.rutasAsignadas = rutasAsignadas;
      modalRef.componentInstance.modals = this;
      return modalRef.result;
    }

    busquedaAvanzadaClientesNgbModal(tipo?) {
        const modalRef = this.modalService.open(BusquedaAvanzadaComponent, { centered: true, backdrop: 'static', size: 'lg' });
        modalRef.componentInstance.tipo = tipo;
        return modalRef.result;
    }

    anularNgbModal(tipo: string, accion = 'Denegar') {
        const modalRef = this.modalService.open(DenegarComponent, { centered: true, backdrop: 'static'});
        modalRef.componentInstance.tipo = tipo;
        modalRef.componentInstance.accion = accion;
        return modalRef.result;
    }

    editarRutaNgbModal(data: any) {
        const modalRef = this.modalService.open(EditarRutaComponent, { centered: true, backdrop: 'static', size: 'lg'});
        modalRef.componentInstance.ruta = data;
        modalRef.componentInstance.modals = this;
        return modalRef.result;
    }

    vistaMapaNgbModal(markers: Array<any>, titulo = 'Vista Mapa') {
        const modalRef = this.modalService.open(VistaMapaComponent, { centered: true, backdrop: 'static', size: 'lg'});
        modalRef.componentInstance.markers = markers;
        modalRef.componentInstance.titulo = titulo;
        return modalRef.result;

    }

    asignarRutasEmpleado(markers: Array<any>) {
        const modalRef = this.modalService.open(VistaMapaComponent, { centered: true, backdrop: 'static', size: 'lg'});
        modalRef.componentInstance.markers = markers;
        return modalRef.result;

    }

    cobroPersonalizadoNgbModal(prestamo) {
        const modalRef = this.modalService.open(ReciboIngresoComponent, { centered: true, backdrop: 'static', size: 'lg'});
        modalRef.componentInstance.prestamo = prestamo;
        modalRef.componentInstance.modals = this;
        return modalRef.result;
    }

   // Abrir modal jquery confirm
   edicionClienteModalJquery( navigate: any, ID_CLIENTE: any, titulo: string,
    btnText: string,
    type: string,
    theme: string = 'modern',
    btnColor: string = 'btn-green',
    icon: string = 'fa fa-user'
    ) {
        $.confirm({
            title: titulo,
            content: '',
            theme: theme,
            type: type,
            icon,
            closeIcon: true,
            typeAnimated: true,
            buttons: {
                boton: {
                    text: btnText,
                    btnClass: btnColor,
                    action: function() {
                        navigate.navigate(['/cliente', ID_CLIENTE]);
                    }
                }
            }
        });
    }

    irAModalJquery( navigate: any, ID: any, nav: string, titulo: string, content,
        btnText: string,
        type: string,
        theme: string = 'modern',
        btnColor: string = 'btn-green',
        icon: string = 'fa fa-user') {
    $.confirm({
        title: titulo,
        content,
        theme: theme,
        type: type,
        icon,
        closeIcon: true,
        typeAnimated: true,
        buttons: {
            prestamo: {
                text: btnText,
                btnClass: btnColor + ' btn-block',
                action: function() {
                 navigate.navigate([`/${nav}`, ID.PRESTAMO]);
                }
            },
            cliente: {
                text: 'Actualizar cliente',
                btnClass: 'btn-orange btn-block',
                action: function() {
                 navigate.navigate([`./editar/cliente`, ID.CLIENTE]);
                }
            }
        }
    });
    }

    vistaEditarPassNgbModal(id) {
        const modalRef = this.modalService.open(EditarPassComponent, { centered: true, backdrop: 'static', size: 'lg'});
        modalRef.componentInstance.id = id;
        return modalRef.result;

    }

    confirmNgbModal(msg, titulo = '¿Estas seguro?') {
        const modalRef = this.modalService.open(ConfirmComponent, { centered: true, backdrop: 'static', });
        modalRef.componentInstance.msg = msg;
        modalRef.componentInstance.titulo = titulo;
        return modalRef.result;
    }

    detalleReciboNgbModal(recibo) {
        const modalRef = this.modalService.open(DetalleComponent, { centered: true, backdrop: 'static'});
        modalRef.componentInstance.recibo = recibo;
        return modalRef.result;
    }

    detalleNotaCreditoNgbModal(notaCredito) {
        const modalRef = this.modalService.open(DetalleNotaCreditoComponent, { centered: true, backdrop: 'static'});
        modalRef.componentInstance.notaCredito = notaCredito;
        return modalRef.result;
    }

    comentarioClienteNgbModal(ID_CLIENTE) {
        const modalRef = this.modalService.open(ComentarioClienteComponent, { centered: true, backdrop: 'static'});
        modalRef.componentInstance.ID_CLIENTE = ID_CLIENTE;
        modalRef.componentInstance.modals = this;
        return modalRef.result;
    }

    recordatorioNgbModal() {
        const modalRef = this.modalService.open(RecordatorioComponent, { centered: true, backdrop: 'static'});
        // modalRef.componentInstance.ID_CLIENTE = ID_CLIENTE;
        return modalRef.result;
    }

    detalleAperturaNgbModal(apertura) {
        const modalRef = this.modalService.open(DetalleAperturaComponent, { centered: true, backdrop: 'static'});
        modalRef.componentInstance.apertura = apertura;
        modalRef.componentInstance.modals = this;
        return modalRef.result;
    }

    cerrarDiaNgbModal(apertura, i, functions) {

        const modalRef = this.modalService.open(
            CerrarDiaComponent,
            { centered: true, backdrop: 'static', size: 'lg', windowClass: 'cuadre'}
        );
        modalRef.componentInstance.apertura = apertura;
        modalRef.componentInstance.modals = this;
        modalRef.componentInstance.i = i;
        modalRef.componentInstance.functions = functions;
        return modalRef.result;
    }

    promptNgbModal(title, label) {
        const modalRef = this.modalService.open(PromptComponent, { centered: true,
            backdrop: 'static'});
        modalRef.componentInstance.titulo = title;
        modalRef.componentInstance.label = label;
        return modalRef.result;
    }

    agreeModal(title: string, content,
        btnText: string,
        type: string,
        theme: string = 'modern',
        btnColor: string = 'btn-green',
        icon: string = 'fa fa-check-square-o') {

            return new Promise((resolve, reject) => {
                $.confirm({
                    title,
                    content,
                    theme: theme,
                    type: type,
                    icon,
                    closeIcon: function() {
                       resolve(false);
                    },
                    typeAnimated: true,
                    buttons: {
                        continue: {
                            text: btnText,
                            btnClass: btnColor + ' btn-block',
                            action: function() {
                                    resolve(true);
                            }
                        }
                    }
                });
            });

    }

    confirmModalJquery(title: string, content,
        type: string,
        theme: string = 'modern',
        columnClass: string = 'col-md-8 col-md-offset-2') {

            return new Promise((resolve, reject) => {
                $.confirm({
                    title,
                    content,
                    theme: theme,
                    type: type,
                    columnClass,
                    closeIcon: function() {
                       resolve(false);
                    },
                    typeAnimated: true,
                    buttons: {
                        continue: {
                            text: 'SI',
                            btnClass: 'btn-green',
                            action: function() {
                                    resolve('SI');
                            }
                        },
                        cancel: {
                            text: 'NO',
                            btnClass: 'btn-red',
                            action: function() {
                                    resolve('NO');
                            }
                        },
                    }
                });
            });

    }

    detalleCerrarDiaNgbModal(apertura, i, functions) {
        const modalRef = this.modalService.open(
            DetalleCierreDiaComponent,
            { centered: true, backdrop: 'static', size: 'lg', windowClass: 'cuadre'}
        );
        modalRef.componentInstance.apertura = apertura;
        modalRef.componentInstance.modals = this;
        modalRef.componentInstance.i = i;
        modalRef.componentInstance.functions = functions;
        return modalRef.result;
    }

    descuentoCuotasNotaCredito(prestamo, prestamoSeleccionado?) {
        const modalRef = this.modalService.open(DescuentoCuotaComponent, { centered: true,
            backdrop: 'static', size: 'lg', windowClass: 'modal-xl'});
        modalRef.componentInstance.datosCliente = prestamo;
        modalRef.componentInstance.prestamoSeleccionado = prestamoSeleccionado;
        modalRef.componentInstance.modals = this;
        return modalRef.result;
    }

    editarGastoNgbModal(data: any, modals) {
        const modalRef = this.modalService.open(EditarGastosComponent, { centered: true, backdrop: 'static', size: 'lg'});
        modalRef.componentInstance.gasto = data;
        modalRef.componentInstance.modals = modals;
        return modalRef.result;
    }

    recordatorios(data: any) {
        const modalRef = this.modalService.open(RecordatoriosModalComponent, { centered: true, backdrop: 'static', size: 'lg'});
        modalRef.componentInstance.recordatorios = data;
        modalRef.componentInstance.modals = this;
        return modalRef;
    }

    recorridoNgbModal(ID_APERTURA) {
        // tslint:disable-next-line:max-line-length
        const modalRef = this.modalService.open(RecorridosComponent, { centered: true, backdrop: 'static', size: 'lg', windowClass: 'modal-xl'});
        modalRef.componentInstance.ID_APERTURA = ID_APERTURA;
        return modalRef.result;

    }

    accesoClienteNgbModal(empleado) {
        // tslint:disable-next-line:max-line-length
        const modalRef = this.modalService.open(AccesoClienteComponent, { centered: true, backdrop: 'static', size: 'lg', windowClass: 'modal-extar-xl' });
        modalRef.componentInstance.empleado = empleado;
        modalRef.componentInstance.modals = this;
        return modalRef.result;
    }

    restablecerContrasenaNgbModal() {
        const modalRef = this.modalService.open(RestablecerContrasenaComponent, { centered: true, backdrop: 'static'});
        return modalRef.result;
    }

    preguntasSecretasNgbModal() {
        const modalRef = this.modalService.open(PreguntasSecretasComponent, { centered: true, backdrop: 'static'});
        return modalRef.result;
    }

    cartaPDFNgbModal(datosCliente) {
        const modalRef = this.modalService.open(CartasPdfComponent, { centered: true,
            backdrop: 'static', size: 'lg', windowClass: 'modal-xl'});
            modalRef.componentInstance.datos = datosCliente;
        return modalRef.result;
    }

    pagareNotarialPDFNgbModal(data: any) {
        const modalRef = this.modalService.open(PagareNotarialModalComponent, { centered: true,
            backdrop: 'static', size: 'lg', windowClass: 'modal-xl'});
        modalRef.componentInstance.datos = data;

        return modalRef.result;
    }

    editarAperturaNgbModal(ID_APERTURA: any) {
        const modalRef = this.modalService.open(EditarAperturaComponent, { centered: true,
            backdrop: 'static', size: 'lg', windowClass: 'modal-xl'});
        modalRef.componentInstance.ID_APERTURA = ID_APERTURA;
        modalRef.componentInstance.modals = this;

        return modalRef.result;
    }

    recuperarClienteDatacreditoNgbModal() {
        const modalRef = this.modalService.open(RecuperarClienteDatacreditoComponent, { centered: true,
            backdrop: 'static', size: 'lg'});
        // modalRef.componentInstance.datos = data;

        return modalRef.result;
    }

    pausarMoraPrestamoNgbModal(ID_PRESTAMO) {
        const modalRef = this.modalService.open(PausarMoraComponent, { centered: true,
            backdrop: 'static', size: 'lg'});
        modalRef.componentInstance.ID_PRESTAMO = ID_PRESTAMO;
        modalRef.componentInstance.modals = this;
        return modalRef.result;
    }

    cartaSaldoNgbModal(datosCliente) {
        const modalRef = this.modalService.open(CartaSaldoModalComponent, { centered: true,
            backdrop: 'static', size: 'lg', windowClass: 'modal-xl'});
            modalRef.componentInstance.datos = datosCliente;
        return modalRef.result;
    }

    timingNgbModal(time: number) {
        const modalRef = this.modalService.open(TimingComponent, { centered: true,
            backdrop: 'static'});
            modalRef.componentInstance.time = time;
        return modalRef.result;
    }

    asignarCompaniaEmpleadosNgbModal(empleado, companiasAsignadas: Array<any>) {
        const modalRef = this.modalService.open(AsignarCompaniaEmpleadoComponent, { centered: true, backdrop: 'static' });
        modalRef.componentInstance.modals = this;
        modalRef.componentInstance.empleado = empleado;
        modalRef.componentInstance.companiasAsignadas = companiasAsignadas;
        return modalRef.result;
    }

    asignarPaginaEmpleadosNgbModal(empleado, paginasAsignadas: Array<any>) {
        const modalRef = this.modalService.open(AsignarPaginaComponent, { centered: true, backdrop: 'static' });
        modalRef.componentInstance.empleado = empleado;
        modalRef.componentInstance.paginasAsignadas = paginasAsignadas;
        return modalRef.result;
    }

    notasClienteNgbModal(cliente) {
        // tslint:disable-next-line:max-line-length
        const modalRef = this.modalService.open(NotasClienteComponent, { centered: true, backdrop: 'static', size: 'lg', windowClass: 'modal-xl' });
        modalRef.componentInstance.cliente = cliente;
        return modalRef.result;
    }

    historialPagosNgbModal(ID_PRESTAMO) {
        // tslint:disable-next-line:max-line-length
        const modalRef = this.modalService.open(HistorialPagoPrestamoComponent, { centered: true, backdrop: 'static', size: 'lg', windowClass: 'modal-xl'});
        modalRef.componentInstance.ID_PRESTAMO = ID_PRESTAMO;
        return modalRef.result;
    }

    importarClientesRutaNgbModal(ID_RUTA) {
        const modalRef = this.modalService.open(
        ImportarClientesRutaComponent,
        { centered: true, backdrop: 'static', size: 'lg', windowClass: 'modal-xl'}
        );
        modalRef.componentInstance.ID_RUTA = ID_RUTA;
        modalRef.componentInstance.modals = this;
        return modalRef.result;
    }

    asignarPermisoEmpleadosNgbModal(empleado, permisosAsignados: Array<any>) {
        const modalRef = this.modalService.open(AsignarPermisoComponent, { centered: true, backdrop: 'static' });
        modalRef.componentInstance.empleado = empleado;
        modalRef.componentInstance.permisosAsignados = permisosAsignados;
        return modalRef.result;
    }

    AddEditRegion(region = {}) {
        const modalRef = this.modalService.open(RegionComponent, { centered: true, backdrop: 'static', size: 'lg' });
        modalRef.componentInstance.region = region;
        modalRef.componentInstance.modals = this;
        return modalRef.result;
      }

     AddEditSubRegion(subRegion) {
        const modalRef = this.modalService.open(SubregionComponent, { centered: true, backdrop: 'static', size: 'lg' });
        modalRef.componentInstance.subRegion = typeof(subRegion) === 'number' ? {} : subRegion;
        modalRef.componentInstance.ID_REGION = typeof(subRegion) === 'number' ? subRegion : 0;
        modalRef.componentInstance.modals = this;
        return modalRef.result;
      }
    seleccionarEmpleadoNgbModal(tipoEmpleado, ruta, ID_EMPLEADO?) {
        const modalRef = this.modalService.open(SeleccionarEmpleadoComponent, { centered: true, backdrop: 'static' });
        modalRef.componentInstance.tipoEmpleado = tipoEmpleado;
        modalRef.componentInstance.ID_EMPLEADO = ID_EMPLEADO;
        modalRef.componentInstance.ruta = ruta;
        return modalRef.result;
    }

    detalleSolicitudNgbModal(ID_SOLICITUD) {
        const modalRef = this.modalService.open(DetalleSolicitudComponent, { centered: true, backdrop: 'static', size: 'lg'});
        modalRef.componentInstance.ID_SOLICITUD = ID_SOLICITUD;
        return modalRef.result;
    }

    verFotosClienteNgbModal(fotos: string[], cliente: any) {
        const modalRef = this.modalService.open(VerFotosClienteComponent, { centered: true, backdrop: 'static', size: 'lg'});
        modalRef.componentInstance.fotos = fotos;
        modalRef.componentInstance.cliente = cliente;
        return modalRef.result;
    }

    historialTelefonosNgbModal(cliente: any) {
        const modalRef = this.modalService.open(HistorialTelefonoComponent, { centered: true, backdrop: 'static', size: 'lg'});
        modalRef.componentInstance.cliente = cliente;
        return modalRef.result;
    }

    generarTokenEmpleadoNgbModal(empleado: string, empleadoId) {
        const modalRef = this.modalService.open(TokenComponent, { centered: true, backdrop: 'static', size: 'lg'});
        modalRef.componentInstance.empleado = empleado;
        modalRef.componentInstance.empleadoId = empleadoId;
        return modalRef.result;
    }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/helpers/alertasModales.ts